__turbopack_context__.v({
  "chip": "BlogCategories-module__QrjD7W__chip",
  "chipActive": "BlogCategories-module__QrjD7W__chipActive",
  "chipDisabled": "BlogCategories-module__QrjD7W__chipDisabled",
  "container": "BlogCategories-module__QrjD7W__container",
});
